import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const StreetEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ street: event.target.value }));
  };

  return (
    <TextField
      label="Street"
      size="small"
      fullWidth
      value={currentVendor?.street || ''}
      onChange={handleChange}
    />
  );
};

export default StreetEdit;
